import React, { Fragment } from "react";
import { Field } from "redux-form";

const SelectFieldComponent = field => {
  return (
    <Fragment>
      {field.label && <label htmlFor={field.input.name}>{field.label}</label>}
      <select
        {...field.input}
        id={field.input.name}
        style={field.style}
        disabled={field.isReadOnly}
      >
        {field.options.map((option, index) => (
          <option value={option.value} key={index}>
            {option.label}
          </option>
        ))}
      </select>
      {field.meta.touched && field.meta.error && (
        <span style={{ color: "red" }}>{field.meta.error}</span>
      )}
    </Fragment>
  );
};

const SelectField = props => <Field {...props} component={SelectFieldComponent} />;

export default SelectField;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/FormField/SelectField.jsx